var map = {
	"./attack/1.wav": "9c55",
	"./attack/2.wav": "872b",
	"./attack/3.wav": "4686",
	"./attack/4.wav": "62bf",
	"./attack/5.wav": "5f38",
	"./attack/6.wav": "ff00",
	"./button/1.wav": "c161",
	"./button/2.wav": "8ffa",
	"./button/3.wav": "3932",
	"./card-drop/1.wav": "9d86",
	"./card-drop/2.wav": "1fac",
	"./card-drop/3.wav": "f49e",
	"./card-drop/4.wav": "6ad8",
	"./card-drop/5.wav": "1fe2",
	"./card-drop/6.wav": "d02e",
	"./card-drop/7.wav": "7677",
	"./card-hover/1.wav": "92d2",
	"./card-hover/2.wav": "d527",
	"./card-hover/3.wav": "afd9",
	"./card-hover/4.wav": "8ecb",
	"./card-hover/5.wav": "e57d",
	"./card-hover/6.wav": "c6c8",
	"./card-hover/7.wav": "5731",
	"./card-hover/8.wav": "1304",
	"./card-select/1.wav": "d5b8",
	"./card-select/2.wav": "a7d6",
	"./card-select/3.wav": "f7c1",
	"./card-select/4.wav": "9355",
	"./card-select/5.wav": "d71b",
	"./death.ogg": "a7d9",
	"./dragon/1.wav": "6308",
	"./dragon/2.wav": "9d43",
	"./dragon/3.wav": "c637",
	"./equipment/1.wav": "30cf",
	"./equipment/2.wav": "9b15",
	"./equipment/3.wav": "a21a",
	"./eyes/1.wav": "8d1b",
	"./eyes/2.wav": "98e2",
	"./eyes/3.wav": "caf8",
	"./fire/1.wav": "46a9",
	"./fire/2.wav": "d5e9",
	"./fire/3.wav": "fea8",
	"./gargoyle/1.wav": "23d3",
	"./gargoyle/2.wav": "d2db",
	"./gargoyle/3.wav": "fce0",
	"./go/1.ogg": "d45b",
	"./gold/1.wav": "aeb0",
	"./gold/2.wav": "f04a",
	"./gold/3.wav": "97dd",
	"./hit/1.wav": "b75d",
	"./hit/2.wav": "e2b2",
	"./hit/3.wav": "4311",
	"./hit/4.wav": "d6c1",
	"./king/1.wav": "94f7",
	"./king/2.wav": "1d7f",
	"./king/3.wav": "db2b",
	"./leaf/1.wav": "fe03",
	"./leaf/2.wav": "a74c",
	"./leaf/3.wav": "6943",
	"./merchant/1.wav": "b905",
	"./merchant/2.wav": "1431",
	"./merchant/3.wav": "f703",
	"./merchant/4.wav": "cc59",
	"./pigeon/1.wav": "796a",
	"./pigeon/2.wav": "3350",
	"./pigeon/3.wav": "0c62",
	"./pikes-trap/1.wav": "6989",
	"./pikes-trap/2.wav": "ff1e",
	"./pikes-trap/3.wav": "d622",
	"./potion/1.wav": "1cac",
	"./potion/2.wav": "c1d4",
	"./puddle/1.wav": "5f4b",
	"./puddle/2.wav": "312b",
	"./puddle/3.wav": "c946",
	"./reroll/1.wav": "6669",
	"./reroll/2.wav": "f84c",
	"./reroll/3.wav": "afd3",
	"./reroll/4.wav": "1797",
	"./reroll/5.wav": "f271",
	"./scroll/1.ogg": "8aca",
	"./step/1.wav": "6ea0",
	"./step/2.wav": "de96",
	"./step/3.wav": "fe6a",
	"./tentacle/1.wav": "d94d",
	"./tentacle/2.wav": "086d",
	"./tentacle/3.wav": "601c",
	"./tongue/1.wav": "6261",
	"./tongue/2.wav": "f2d7",
	"./tongue/3.wav": "e88f",
	"./unlock-character.wav": "afb8",
	"./vampire/1.wav": "aebe",
	"./vampire/2.wav": "fb6e",
	"./vampire/3.wav": "a076",
	"./wolf-trap/1.wav": "8282",
	"./wolf-trap/2.wav": "f385",
	"./wolf-trap/3.wav": "b199"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac03";